import { Component, Vue, Prop } from 'vue-property-decorator';
import { isFunction } from 'lodash';

@Component<SideMenu>({ })
export default class SideMenu extends Vue {
  @Prop({ default: '' })
  protected title!: string;

  @Prop({ default: () => [] })
  protected items!: Item[];

  protected hasItems() {
    let hasItems = false;
    this.items.forEach((item: Item) => {
      if (this.isVisible(item)) {
        hasItems = true;
      }
    });

    return hasItems;
  }

  protected isVisible(item: Item) {
    if (item.visible === undefined) { return true; }

    return isFunction(item.visible) ? item.visible() : item.visible;
  }

  protected isFunction(item: Item) {
    return isFunction(item);
  }
}

export interface Item {
  title: string;
  link: string;
  icon?: string;
  type?: string;
  visible?: (() => boolean) | boolean;
}
